import {useEffect} from 'react';

import {FIELDS_PATTERN} from 'src/modules/event-create/constants';

import {Icons} from '@pb/kit-component-icon';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

type Props = {
    selectedEventCode: string,
    setSelectedEventCode: (value: string) => void,
};

export const SelectedEventCodeValidator = (props: Props) => {
    const {
        selectedEventCode,
        setSelectedEventCode,
    } = props;

    const {onCreateNote} = usePushNotification();

    useEffect(() => {
        if (selectedEventCode.match(FIELDS_PATTERN.name)) {
            onCreateNote({
                id: 'event-code-warning',
                status: Status.WARNING,
                message: 'Only Latin characters, numbers and _ symbol are allowed',
                buttonProps: {iconProps: {type: Icons.CLOSE}},
                autoHideTimeout: 10000,
            });

            setSelectedEventCode(selectedEventCode.replace(FIELDS_PATTERN.name, ''));
        }
    }, [onCreateNote, selectedEventCode, setSelectedEventCode]);

    return null;
};
